import { configureStore } from "@reduxjs/toolkit";
import { modelReducer } from "./Reducer/modelReducer";
import { authReducer } from "./Reducer/AuthReducer";
import { userapiReducer } from "./Reducer/UserApiReducer";
import { HoroscopeReducer } from "./Reducer/HoroscopeReducer";
import { BlogReducer } from "./Reducer/BlogReducer";
import { WorldCityReducer } from "./Reducer/WorldCityReducer";
import { HomeContentReducer } from "./Reducer/HomeContentReducer";
import { CounsellorApiReducer } from "./Reducer/CounsellorApiReducer";

const store = configureStore({
    reducer:{
        auth: authReducer,
        mymodel: modelReducer,
        user: userapiReducer,
        horoscope: HoroscopeReducer,
        blog: BlogReducer,
        worldcity: WorldCityReducer,
        home: HomeContentReducer,
        Counsellor: CounsellorApiReducer,
    },

});

export default store;

 export const server = 'https://manageonline.in/demo/mibhagya/WEB_V21/';
//export const server = 'https://mibhagya.com/WEB_V21/';
